import api from '../services/api';

export interface DateRangeParams {
  startDate?: string;
  endDate?: string;
}

export const reportsApi = {
  getProductionSummary: (params: DateRangeParams) =>
    api.get('/reports/production-summary', { params }),

  getWorkerPerformance: (params: DateRangeParams & { worker_id?: string; job_type?: string }) =>
    api.get('/reports/worker-performance', { params }),

  getStitchingPending: (params: DateRangeParams) =>
    api.get('/reports/stitching-pending', { params }),

  getInventoryConsumption: (params: DateRangeParams & { material_type?: string }) =>
    api.get('/reports/inventory-consumption', { params }),

  getJobWorkAgeing: (params: DateRangeParams & { status?: string; vendor_id?: number }) =>
    api.get('/reports/job-work-ageing', { params }),

  getDispatchDelivery: (params: DateRangeParams) =>
    api.get('/reports/dispatch-delivery', { params }),

  getQualityControl: (params: DateRangeParams) =>
    api.get('/reports/quality-control', { params }),

  getPressProductivity: (params: DateRangeParams & { worker_id?: string }) =>
    api.get('/reports/press-productivity', { params }),

  getPendingPO: (params: { vendor_id?: number }) =>
    api.get('/reports/po-fulfillment', { params }),

  getPendingBarcoding: () =>
    api.get('/reports/pending-barcoding'),

  getWorkerPerformanceDetail: (workerId: string, params: DateRangeParams) =>
    api.get(`/reports/worker-performance/${workerId}/detail`, { params }),
};
